module.exports = __webpack_public_path__ + "media/icons/human_ai-58588b07.svg";